import { CustomerSettingsType, } from "../../../types/types";
import { api } from "../api";

/**
 * updateSettingsByCustomer - Function that updates on database the customer parameters  
 * /customer-parameters  
 * method PUT  
 * @async-function
 */
const updateSettingsByCustomer = async (token: string, model: CustomerSettingsType) => {
    const response = await api.put(
        `/customer-parameters`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default updateSettingsByCustomer;